import React from 'react'

export const useShowSearchButton = (index: number, ref: React.RefObject<HTMLDivElement>) => {
  const [isElementVisible, setIsElementVisible] = React.useState<boolean>(false)

  React.useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        setIsElementVisible(entry.isIntersecting) // Якщо елемент видно, змінюємо стан
      },
      {
        // root: document.querySelector(`${styles.participants_list}`), // За замовчуванням viewport
        root: null, // За замовчуванням viewport
        threshold: 0.1, // Частка видимості елемента (10%)
      },
    )

    if (ref.current) {
      observer.observe(ref.current) // Спостерігаємо за елементом
    }

    return () => {
      if (ref.current) {
        observer.unobserve(ref.current) // Зупиняємо спостереження при демоунті
      }
    }
  }, [index])

  return {
    isElementVisible,
  }
}
